import { CreateItemGqlError, CreateItemGqlStatus } from '../../../../types';
import { CreateCustomFieldValueCacheKeys } from '../../customFieldValuesTypes';

import { CACHE_CREATE_CUSTOM_FIELD_VALUE_QUERY } from '../../queries/cacheCreateCustomFieldValue.query';

import { useCacheCreateQuery } from '../../../common/reactQuery/hooks/useCacheCreateQuery';

interface CacheCreateCustomFieldValueOptions {
  cacheKeys?: CreateCustomFieldValueCacheKeys;
}

export interface CacheCreateCustomFieldValueInput {
  companyUuid: string;
  customFieldUuid: string;
  defaultAt?: string;
  text: string;
}

export interface CacheCreateCustomFieldValueRecord {
  companyId: number;
  createdAt: string;
  customFieldId: number;
  defaultAt: string | null;
  id: string;
  text: string;
  updatedAt: string;
  uuid: string;
}

export interface CacheCreateCustomFieldValueResponse {
  createCustomFieldValue: {
    status: CreateItemGqlStatus;
    record: CacheCreateCustomFieldValueRecord;
    errors: CreateItemGqlError;
    recordId: string;
    recordNanoId?: string;
    recordUuid?: string;
  };
}

export interface CacheCreateCustomFieldValueType {
  fullMessages: string[];
}

const action = 'createCustomFieldValue';

function useCacheCreateCustomFieldValue({
  cacheKeys
}: CacheCreateCustomFieldValueOptions = {}) {
  const {
    createCacheQuery,
    createCacheQueryData,
    createCacheQueryError,
    createCacheQueryErrorMessage,
    createCacheQueryLoading,
    createCacheQueryReset
  } = useCacheCreateQuery<
    CacheCreateCustomFieldValueInput,
    CacheCreateCustomFieldValueResponse,
    CacheCreateCustomFieldValueType,
    CacheCreateCustomFieldValueRecord
  >({
    action,
    query: CACHE_CREATE_CUSTOM_FIELD_VALUE_QUERY,
    cacheKeys
  });

  return {
    createCustomFieldValue: createCacheQuery,
    createCustomFieldValueData: createCacheQueryData,
    createCustomFieldValueError: createCacheQueryError,
    createCustomFieldValueErrorMessage: createCacheQueryErrorMessage,
    createCustomFieldValueLoading: createCacheQueryLoading,
    createCustomFieldValueReset: createCacheQueryReset
  };
}

export default useCacheCreateCustomFieldValue;
